(() => {
  const previousValues = window.WeakMap ? new WeakMap() : new Map();
  const deletedRows = [];
  const focusableElems = window.swinger.focusableElements;
  let cartViewAlreadyTracked = false;
  const trackCartView = (result) => {
    if (cartViewAlreadyTracked) {
      return;
    }

    cartViewAlreadyTracked = true;

    const items = result.items.map((item) => ({
      itemNumber: `${item.itemNumber}`,
      transactionType: item.contentType === 'vod_rental' ? 'rent' : 'buy',
    }));
    window.swinger.tracking.trackViewCart(items, result.total);
  };
  const trackAdcell = (result) => {
    const vatPercentage = window.swinger.user.getVatPercentage();

    const adCellQueryParams = {
      method: 'basket',
      productSeparator: '|',
      productIds: result.items.map((item) => encodeURIComponent(`${item.itemNumber}`)).join('|'),
      quantities: result.items.map((item) => encodeURIComponent(`${item.quantity || 1}`)).join('|'),
      basketProductCount: result.items.reduce((acc, item) => acc + (item.quantity || 1), 0),
      basketTotal: Math.round((result.total * 10000) / (100 + vatPercentage)) / 100,
    };

    window.swinger.retargeting.adcell.container(adCellQueryParams);
  };
  const reducer = () => (state, action) => {
    switch (action.type) {
      case 'UPDATE':
        Object.keys(action.value).forEach((key) => {
          state[key] = action.value[key];
        });
        if (action.value.items && Array.isArray(action.value.items)) {
          state.regularTotal = state.regularTotal || action.value.items.reduce((acc, item) => acc + item.regularPrice, 0);
          state.total = state.total || action.value.items.reduce((acc, item) => acc + item.effectivePrice, 0);
        }
        break;

      default:
        break;
    }
    return state;
  };

  window.swinger.app({
    type: 'cart',
    component: 'cart',
    reducer: reducer(),
  })
    .then((app) => {
      const apiBase = window.swinger.config.apiBase;
      const cartRoute = `${apiBase}${window.swinger.config.apiRoutes.cart}`;
      const cartItemRoute = `${cartRoute}/item`;
      const cartCouponRoute = `${cartRoute}/coupon`;
      const cartEPointsRoute = `${cartRoute}/points`;
      let lastItemTotal;
      let lastEpointClick;
      let lastAmountOfPoints;

      const updateStore = (result) => {
        app.store.dispatch({
          type: 'UPDATE',
          value: result,
        });

        if (result.shipping && lastItemTotal !== result.itemTotal) {
          lastItemTotal = result.itemTotal;
          const diff = Math.max(0, result.shipping.freeShippingThreshold - result.itemTotal);
          window.swinger.i18n()
            .then((i18n) => {
              window.swinger.snackbar.create({
                id: 'shipping',
                isSelfclosing: diff === 0,
                children: [
                  {
                    component: 'notification',
                    data: diff > 0 ? {
                      type: 'info',
                      text: i18n('ui.cart.free-shipping-reminder', {
                        diff: `${window.swinger.currency.formatCurrency(diff)} ${window.swinger.currency.currencySymbol()}`,
                        carrierName: result.shipping.carrier,
                      }),
                    } : {
                      type: 'success',
                      text: i18n('ui.cart.free-shipping'),
                    },
                  },
                ],
              });
            })
            .catch(console.info);
        }
      };

      let lastUpdateCartContent;
      const updateCartContents = () => {
        const timestamp = performance.now();

        lastUpdateCartContent = timestamp;

        window.swinger
          .ajax(`${cartRoute}?order=added_date`)
          .then((result) => {
            const state = app.store.getState();
            // The following is written as ternary to saveguard against deployment bugs
            result.userpoints = window.swinger.user.getPoints ? window.swinger.user.getPoints() : 0;

            if (lastUpdateCartContent !== timestamp) {
              return;
            }

            const selectedPoints = result.redeemablePoints.find((item) => item.selected);
            if (selectedPoints && selectedPoints.points) {
              lastAmountOfPoints = selectedPoints.points;
            } else {
              lastAmountOfPoints = 0;
            }

            if (typeof state.items === 'undefined') {
              updateStore(result);
            }

            if (result.pagination && result.pagination.pageCount > 1) {
              const numberOfPagesLeft = result.pagination.pageCount - 1;
              const urls = Array(numberOfPagesLeft).fill('').map((entry, index) => `${cartRoute}?page=${index + 2}&order=added_date`);

              Promise
                .all(urls.map((url) => window.swinger.ajax(url)))
                .then((results) => {
                  result.items = [].concat(result.items, ...results.map((result) => result.items));

                  if (lastUpdateCartContent !== timestamp) {
                    return;
                  }

                  updateStore(result);
                  trackCartView(result);
                  trackAdcell(result);
                })
                .catch((e) => {
                  console.log('An error occurred while fetching the remaining cart pages:', e);
                });
            } else {
              updateStore(result);
              trackCartView(result);
              trackAdcell(result);
            }
          })
          .catch((e) => {
            console.log('An error occurred while fetching the initial cart page:', e);
          });
      };
      const deleteItem = (tableRow) => {
        const kind = `${tableRow.getAttribute('data-kind')}`;
        const itemNumber = `${tableRow.getAttribute('data-id')}`;
        const itemName = `${tableRow.getAttribute('data-name')}`;
        let promise = Promise.resolve('yes');
        let url = `${cartItemRoute}?itemNumber=${itemNumber}`;

        switch (kind) {
          default:
            if (itemNumber && window.swinger.config.points) {
              const state = app.store.getState();
              const pointsRedeemedSelectedItem = state.redeemablePoints.find((item) => item.selected);

              if (pointsRedeemedSelectedItem) {
                const redeemedAmount = pointsRedeemedSelectedItem.amount;
                const item = state.items.find((item) => `${item.itemNumber}` === `${itemNumber}`);
                const itemPrice = item.effectivePrice;
                const itemTotalPrice = state.items.reduce((acc, item) => {
                  acc += (item.effectivePrice * (item.quantity || 1));
                  return acc;
                }, 0);

                if ((itemTotalPrice - itemPrice) < redeemedAmount) {
                  promise = window.swinger.i18n().then((i18n) => window.swinger.confirm({
                    text: i18n('ui.cart.points.confirm-remove-product.request'),
                    options: [
                      {
                        label: i18n('ui.cart.points.confirm-remove-product.cancel'),
                        value: 'no',
                      },
                      {
                        label: i18n('ui.cart.points.confirm-remove-product.confirm'),
                        value: 'yes',
                        suggested: true,
                      },
                    ],
                  }));
                }
              }
            }
            break;

          case 'coupon':
            url = `${cartCouponRoute}?code=${itemNumber}`;
            break;

          case 'epoints':
            url = `${cartEPointsRoute}`;
            break;
        }

        promise
          .then((result) => {
            if (result !== 'yes') {
              return;
            }

            tableRow.classList.add('swinger-cart__table-row--deleted');

            window.swinger
              .ajax(url, {
                method: 'DELETE',
              })
              .then(() => {
                const nextAreaToFocus = tableRow.nextElementSibling || tableRow.previousElementSibling || document.querySelector('.swinger-cart');

                if (nextAreaToFocus) {
                  const nextElementToFocus = nextAreaToFocus.querySelector(focusableElems.join(','));

                  if (nextElementToFocus) {
                    nextElementToFocus.focus();
                  }
                }

                window.setTimeout(() => {
                  try {
                    tableRow.parentNode.removeChild(tableRow);
                    deletedRows.push(deletedRows);
                  } catch (e) {
                    // noop
                  }

                  updateCartContents();

                  window.swinger.i18n()
                    .then((i18n) => {
                      let message;

                      switch (kind) {
                        default:
                          break;

                        case 'item':
                          window.swinger.user.removeCartItem(itemNumber);
                          window.swinger.tracking.trackRemoveFromCart(itemNumber);
                          message = 'ui.cart.remove-item-success-message';
                          break;

                        case 'coupon':
                          message = 'ui.cart.coupon.remove-success-message';
                          break;

                        case 'epoints':
                          {
                            const checked = window.swinger.$('[name="epoints"]:checked');
                            if (checked.length) {
                              checked[0].checked = false;
                            }
                          }
                          message = 'ui.cart.points.remove-success-message';
                          break;
                      }

                      window.swinger.snackbar.create({
                        isSelfclosing: true,
                        children: [
                          {
                            component: 'notification',
                            data: {
                              type: 'success',
                              text: i18n(message, {
                                itemnumber: itemNumber,
                                name: itemName,
                              }),
                            },
                          },
                        ],
                      });
                    })
                    .catch(console.info);
                }, 350);
              })
              .catch((e) => {
                tableRow.classList.remove('swinger-cart__table-row--deleted');
                console.log(`An error occurred while trying to delete item ${itemNumber}:`, e);
              });
          })
          .catch(console.log);
      };

      updateCartContents();

      document.addEventListener('swinger.user:authchange', () => {
        const state = app.store.getState();
        const cartItems = window.swinger.user.getCartItems();

        if (cartItems && state.items && cartItems.length === state.items.length) {
          return;
        }

        updateCartContents();
      });

      app.bindEvent('focus', '[data-id] [name="quantity"]', (e) => {
        const elem = window.swinger.eventHub.getTarget(e);

        if (elem.value === '') {
          return;
        }

        previousValues.set(elem, elem.value);
      });

      app.bindEvent('change', '[data-id] [name="quantity"]', (e) => {
        const input = window.swinger.eventHub.getTarget(e);
        const id = input.closest('[data-id]').getAttribute('data-id');
        const quantity = parseInt(input.value, 10);

        window.swinger
          .ajax(`${cartItemRoute}?itemNumber=${id}`, {
            method: 'PUT',
            body: JSON.stringify({
              itemNumber: id,
              quantity,
            }, null, 4),
          })
          .then(() => {
            updateCartContents();
          })
          .catch((e) => {
            const previousValue = previousValues.get(input);

            input.value = previousValue;

            console.log(`An error occurred while trying to update the quantity of item ${id}:`, e);

            if (!e) {
              return;
            }

            window.swinger.snackbar.create({
              isSelfclosing: true,
              children: [
                {
                  component: 'notification',
                  data: {
                    type: 'error',
                    text: e,
                  },
                },
              ],
            });
          });
      });

      app.bindEvent('click', '.swinger-cart__table-row .swinger-button-delete', (e) => {
        const button = window.swinger.eventHub.getTarget(e);
        const tableRow = button.closest('.swinger-cart__table-row');

        deleteItem(tableRow);
      });

      app.bindEvent('click', '[data-id] .swinger-cart__button-like', (e) => {
        if (!window.swinger.user.isLoggedIn()) {
          return;
        }

        const button = window.swinger.eventHub.getTarget(e);
        const tableRow = button.closest('[data-id]');
        const itemNumber = `${tableRow.getAttribute('data-id')}`;
        const itemType = button.getAttribute('data-type');

        button.setAttribute('aria-pressed', 'true');
        button.classList.add('was-just-toggled');
        window.swinger.user.setItemLikeState(itemType, itemNumber, true);
        window.swinger.tracking.trackAddToWishlist(itemNumber);

        window.setTimeout(() => {
          button.classList.remove('was-just-toggled');
          deleteItem(tableRow);
        }, 700);
      });

      app.bindEvent('submit', '.swinger-form[name="coupon"]', (e) => {
        const form = window.swinger.eventHub.getTarget(e);
        const input = form.querySelector('[name="code"]');
        const submit = form.querySelector('[type="submit"]');
        let code = input.value;

        if (code) {
          code = code.trim();

          window.swinger
            .ajax(`${cartCouponRoute}`, {
              method: 'POST',
              body: JSON.stringify({
                code,
              }, null, 4),
            })
            .then(() => {
              form.reset();
              submit.removeAttribute('disabled');

              updateCartContents();

              window.swinger.i18n()
                .then((i18n) => {
                  window.swinger.snackbar.create({
                    isSelfclosing: true,
                    children: [
                      {
                        component: 'notification',
                        data: {
                          type: 'success',
                          text: i18n('ui.cart.coupon.add-success-message', { code }),
                        },
                      },
                    ],
                  });
                })
                .catch(console.info);
            })
            .catch((e) => {
              console.log(e);
              console.log(`An error occurred while trying to add the coupon ${code}`);

              form.reset();
              submit.removeAttribute('disabled');

              window.swinger.i18n()
                .then((i18n) => {
                  window.swinger.snackbar.create({
                    isSelfclosing: true,
                    children: [
                      {
                        component: 'notification',
                        data: {
                          type: 'error',
                          text: typeof e === 'string' ? e : i18n('ui.cart.coupon.add-error-message', { code }),
                        },
                      },
                    ],
                  });
                })
                .catch(console.info);
            });
        }

        e.preventDefault();
      });

      app.bindEvent('click keyup', '[name="epoints"]', (e) => {
        if (e.type === 'keyup' && e.key !== ' ') {
          return;
        }

        const input = window.swinger.eventHub.getTarget(e);
        const inputPointValue = Number(input.value);
        const points = lastAmountOfPoints === inputPointValue ? 0 : inputPointValue;
        const amount = input.getAttribute('data-amount');
        const timestamp = e.timeStamp;

        lastEpointClick = timestamp;
        lastAmountOfPoints = points;
        input.checked = !!points;

        window.swinger
          .ajax(`${cartEPointsRoute}`, {
            method: points ? 'PUT' : 'DELETE',
            body: points ? JSON.stringify({
              points,
            }, null, 4) : undefined,
          })
          .then(() => {
            if (lastEpointClick !== timestamp) {
              return;
            }
            updateCartContents();

            window.swinger.i18n()
              .then((i18n) => {
                window.swinger.snackbar.create({
                  isSelfclosing: true,
                  children: [
                    {
                      component: 'notification',
                      data: {
                        type: 'success',
                        text: i18n(`ui.cart.points.${points ? 'add' : 'remove'}-success-message`, { points, amount }),
                      },
                    },
                  ],
                });
              })
              .catch(console.info);
          })
          .catch((e) => {
            console.log(`An error occurred while trying to ${points ? 'add' : 'remove'} points`);

            window.swinger.i18n()
              .then((i18n) => {
                window.swinger.snackbar.create({
                  isSelfclosing: true,
                  children: [
                    {
                      component: 'notification',
                      data: {
                        type: 'error',
                        text: typeof e === 'string' ? e : i18n(`ui.cart.coupon.${points ? 'add' : 'remove'}-error-message`, { points, amount }),
                      },
                    },
                  ],
                });
              })
              .catch(console.info);
          });

        e.preventDefault();
      });
    })
    .catch(console.info);
})();



// WEBPACK FOOTER //
// ./src/widgets/cart/cart.js